import { configureStore } from '@reduxjs/toolkit'
import exercisesReducer from './store/exercisesSlice'
import resultsReducer from './store/resultsSlice'
import catalogReducer from './store/catalogSlice'
import postsReducer from './store/postsSlice'
import commentsReducer from './store/commentsSlice'
import buddiesReducer from './store/buddiesSlice'
export default configureStore({
    reducer: {
        exercises: exercisesReducer,
        results: resultsReducer,
        catalog: catalogReducer,
        posts: postsReducer,
        comments: commentsReducer,
        buddies: buddiesReducer
    },
})